/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';

import { Button, Icon, Modal } from '@mairistem/composants';
import { request } from '@mairistem/tools';

import { URL_MENTIONS } from '@/constants';
import type { MentionActe } from '@/types';

import MODAL_HEADER_STYLE from './modalStyles';

interface ModalSupprimerMentionProps {
  mention?: Partial<MentionActe> | null;
  onClose: () => void;
  onDeleted: () => void;
}

const ModalSupprimerMention = (props: ModalSupprimerMentionProps) => {
  const { mention, onClose, onDeleted } = props;

  const [deleting, setDeleting] = React.useState(false);

  const handleDelete = React.useCallback(() => {
    if (_.isNil(mention?.identifiant)) {
      return;
    }

    setDeleting(true);
    request
      .delete(`${URL_MENTIONS}/${mention?.identifiant}`)
      .then(() => {
        onDeleted();
        onClose();
      })
      .catch(() => {
        toast.error(
          'Une erreur est survenue lors de la suppression de la mention',
        );
      })
      .finally(() => {
        setDeleting(false);
      });
  }, [mention, onDeleted, onClose]);

  return (
    <Modal open={!_.isNil(mention)} onClose={onClose} size="small">
      {/* @ts-ignore */}
      <Modal.Header
        style={MODAL_HEADER_STYLE}
        content="Suppression d'une mention"
      />
      <Modal.Content>
        <p>
          {`Supprimer la mention n° ${mention?.numero ?? ''} « ${mention?.titre ?? ''} » ?`}
        </p>
        <p>Cette action est définitive.</p>
      </Modal.Content>
      <Modal.Actions>
        <Button data-testid="mention-suppression-annuler" onClick={onClose}>
          <Icon name="close" />
          Annuler
        </Button>
        <Button
          negative
          data-testid="mention-suppression-confirmer"
          loading={deleting}
          disabled={deleting}
          onClick={handleDelete}
        >
          <Icon name="trash" />
          Supprimer
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalSupprimerMention;
